import {
  OPERATOR_TYPES_1,
  OPERATOR_TYPES_3,
} from 'dashboard/components/widgets/FilterInput/FilterOperatorTypes.js';

export const toolFilterTypes = [
  {
    attributeKey: 'name',
    attributeI18nKey: 'Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'type',
    attributeI18nKey: 'Type',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
];

export const FilterAttributList = [
  {
    key: 'name',
    name: 'AI.TOOLS.FILTERS.FILTER_KEYS.NAME',
  },
  {
    key: 'type',
    name: 'AI.TOOLS.FILTERS.FILTER_KEYS.TYPE',
  },
];

// export const TOOL_TYPE = {
//     CLIENT: 'client',
//     WEBHOOK: "webhook",
// }
export const TOOL_KIND = {
  WEBHOOK: 0,
  CLIENT: 1,
};
export const TOOL_TYPE_LIST = [
  {
    id: TOOL_KIND.WEBHOOK,
    title: 'AI.TOOLS.FILTERS.TYPE_LIST.WEBHOOK',
  },
  {
    id: TOOL_KIND.CLIENT,
    title: 'AI.TOOLS.FILTERS.TYPE_LIST.CLIENT',
  },
];

export const TOOL_KIND_STRING = {
  PRECONFIGURE: 'preconfigure',
};
export const SYSTEM_TOOL_IDS = {
  END_CALL: 'end_call',
  TRANSFER_TO_AGENT: 'transfer_to_agent',
};
export const SYSTEM_TOOLS = [
  { id: SYSTEM_TOOL_IDS.END_CALL, name: 'End conversation' },
  { id: SYSTEM_TOOL_IDS.TRANSFER_TO_AGENT, name: 'Transfer to agent' },
];

export const KNOWLEDGE_TYPE = {
  URL: 'url',
  FILE: 'file',
};

export const knowledgeFilterTypes = [
  {
    attributeKey: 'name',
    attributeI18nKey: 'Name',
    inputType: 'plain_text',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_3,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'kind',
    attributeI18nKey: 'Type',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
];

export const KnowledgeFilterAttributList = [
  {
    key: 'name',
    name: 'AI.KNOWLEDGE.FILTERS.FILTER_KEYS.NAME',
  },
  {
    key: 'kind',
    name: 'AI.KNOWLEDGE.FILTERS.FILTER_KEYS.KIND',
  },
];

export const KNOWLEDGE_TYPE_LIST = [
  {
    id: KNOWLEDGE_TYPE.URL,
    title: 'AI.KNOWLEDGE.FILTERS.TYPE_LIST.URL',
  },
  {
    id: KNOWLEDGE_TYPE.FILE,
    title: 'AI.KNOWLEDGE.FILTERS.TYPE_LIST.FILE',
  },
];

export const REPORT_COST_TYPE = {
  LLM: 'LLM',
  VISION: 'Vision',
  AUDIO: 'Audio',
  EMBEDDING: 'Embedding',
  ANALYTICS: 'Analytics',
};

export const REPORT_COST_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
};

export const reportCostFilterTypes = [
  {
    attributeKey: 'type',
    attributeI18nKey: 'Type',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
  {
    attributeKey: 'status',
    attributeI18nKey: 'Status',
    inputType: 'search_select',
    dataType: 'text',
    filterOperators: OPERATOR_TYPES_1,
    attribute_type: 'standard',
  },
];

export const reportCostFilterAttributList = [
  {
    key: 'type',
    name: 'AI.REPORT_COST.TABLE_HEADER.TYPE',
  },
  {
    key: 'status',
    name: 'AI.REPORT_COST.TABLE_HEADER.STATUS',
  },
];

export const reportCostTypeList = [
  {
    id: REPORT_COST_TYPE.LLM,
    title: 'AI.REPORT_COST.TYPE.LLM',
  },
  {
    id: REPORT_COST_TYPE.VISION,
    title: 'AI.REPORT_COST.TYPE.VISION',
  },
  {
    id: REPORT_COST_TYPE.AUDIO,
    title: 'AI.REPORT_COST.TYPE.AUDIO',
  },
  {
    id: REPORT_COST_TYPE.EMBEDDING,
    title: 'AI.REPORT_COST.TYPE.EMBEDDING',
  },
  {
    id: REPORT_COST_TYPE.ANALYTICS,
    title: 'AI.REPORT_COST.TYPE.ANALYTICS',
  },
];

export const reportCostStatusList = [
  {
    id: REPORT_COST_STATUS.ACTIVE,
    title: 'AI.REPORT_COST.STATUS.ACTIVE',
  },
  {
    id: REPORT_COST_STATUS.INACTIVE,
    title: 'AI.REPORT_COST.STATUS.INACTIVE',
  },
];
